import axios from './axiosService';

export default {
  getDisclaimers() {
    return axios.get(`/api/disclaimers`)
      .then(response => response.data);
  },
  getDisclaimer(disclaimerID) {
    return axios.get(`/api/disclaimers/${disclaimerID}`)
      .then(response => response.data);
  },
  deleteDisclaimer(disclaimerID) {
    return axios.delete(`/api/disclaimers/${disclaimerID}`)
      .then(response => response.data);
  },
  initForm(disclaimer = null) {
    return {
      name: disclaimer ? disclaimer.name : null,
      title: disclaimer ? disclaimer.name : null,
      content: disclaimer ? disclaimer.content : null,
      close_button: disclaimer ? disclaimer.closeButton : null,
      open_button: disclaimer ? disclaimer.open : null,
      status: disclaimer ? disclaimer.status : 'Active',
      presentations: disclaimer?.presentations ? disclaimer.presentations.map(p => p.id) : [],
    }
  }
}
